// 定义初始状态
const initialState = {
  notification: {
    open: false,
    message: '',
    type: 'info' // 'success', 'error', 'warning', 'info'
  },
  languages: [],
  statuses: []
};

// 定义动作类型
const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
const SET_LANGUAGES = 'SET_LANGUAGES';
const SET_STATUSES = 'SET_STATUSES';

// UI reducer
const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_NOTIFICATION:
      return {
        ...state,
        notification: {
          open: true,
          message: action.payload.message,
          type: action.payload.type || 'info'
        }
      };
    case HIDE_NOTIFICATION:
      return {
        ...state,
        notification: {
          ...state.notification,
          open: false
        }
      };
    case SET_LANGUAGES:
      return {
        ...state,
        languages: action.payload
      };
    case SET_STATUSES:
      return {
        ...state,
        statuses: action.payload
      };
    default:
      return state;
  }
};

export default uiReducer; 